'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.2.11';
//# sourceMappingURL=Version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Version.js
// module id = 351
// module chunks = 42657473041956 79611799117203 201563372448855 213534597649335